import { Add } from '@mui/icons-material'
import { styled } from '@mui/material'

export const StyledAdd = styled(Add)(`
  line-height: 1;
  font-size: 15px;
  font-weight: 400;
`)
